import React, { useState } from "react";
import { Check, X } from "lucide-react";

const ADD_NEW = "__add_new__";

export const SourceSelect = ({ value, sources = [], onChange, className, testid = "source-select" }) => {
  const [adding, setAdding] = useState(false);
  const [draft, setDraft] = useState("");
  const options = value && !sources.some((s) => s.toLowerCase() === value.toLowerCase()) ? [...sources, value] : sources;

  const commit = () => {
    const v = draft.trim();
    if (v) onChange(v);
    setAdding(false);
    setDraft("");
  };

  if (adding) {
    return (
      <div className="flex items-center gap-1.5">
        <input
          data-testid={`${testid}-new-input`}
          autoFocus
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); commit(); } if (e.key === "Escape") setAdding(false); }}
          placeholder="New lead source…"
          className={className}
        />
        <button type="button" data-testid={`${testid}-new-save`} onClick={commit} className="rounded-md bg-[#0066ff] p-2 text-white hover:bg-[#0052cc]" title="Add source">
          <Check size={14} />
        </button>
        <button type="button" data-testid={`${testid}-new-cancel`} onClick={() => setAdding(false)} className="rounded-md border border-zinc-200 p-2 text-zinc-500 hover:bg-zinc-50" title="Cancel">
          <X size={14} />
        </button>
      </div>
    );
  }

  return (
    <select
      data-testid={testid}
      value={value || ""}
      onChange={(e) => (e.target.value === ADD_NEW ? setAdding(true) : onChange(e.target.value))}
      className={className}
    >
      <option value="">Unknown / not set</option>
      {options.map((s) => (<option key={s} value={s}>{s}</option>))}
      <option value={ADD_NEW}>+ Add new source…</option>
    </select>
  );
};
